<template>
  <div>
    <div
      class="
                p-0 flex flex-col items-center justify-center border-blue-200 border-solid border rounded-lg
                md:grid md:grid-cols-4 md:content-center 
            "
    >
      <div 
        class="
                    flex justify-center text-indigo-600 text-lg font-normal py-5 border-b border-blue-200 border-solid w-full px-5
                    md:col-span-1 md:px-10 md:border-b-0
                "
      >
        <p>{{ title }}</p>
      </div>
      <div class="md:col-span-3 border-blue-200 border-solid md:border-l">
        <div 
          v-for="(val, lib) in list" 
          :key="lib"
          class="
                        first:rounded-t-lg last:rounded-b-lg
                        odd:bg-white
                        text-gray-900 text-sm font-light bg-indigo-100 bg-opacity-50 py-5
                        md:py-0 md:h-20
                    "
        >
          <div class="flex flex-row items-center justify-center md:h-20 w-full">
            <p class="w-9/10 mx-5">
              {{ lib }}
            </p>

            <div class="mr-5 w-1/10">
              <checkbox-indigo
                :disabled="isDisabled"
                :value="val" 
                @input="(newValue) => {changeValue({key:lib, value:newValue});}"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CheckboxIndigo from './Inputs/CheckboxIndigo.vue';

export default {
  props:{
    title: String,
    list: (Array, Object),
    isDisabled:{
      type: Boolean,
      required: false,
      default: false,
    }
  },

  data(){
    return {
      //
    };
  },

  methods:{
    changeValue(infos){
      this.$emit('changeValue', infos);
    }
  },

  components:{
    CheckboxIndigo,
  },
};
</script>